import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "ms-2 badge bg-info rounded-4"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right ms-auto" }, null, -1)

import { useMainStore } from "@/store";
import { EOffcanvasViews, navigateCanvas } from "../OffcanvasViewsConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileEdit',
  setup(__props) {

const { session } = useMainStore();

const items = [
  {
    value: "Nome e telefone",
    action: () => navigateCanvas(EOffcanvasViews.account_update, null, false),
    icon: "fa-solid fa-user",
    enabled: true,
  },
  {
    value: "Imagem de perfil",
    action: () => navigateCanvas(EOffcanvasViews.profile_image, null, false),
    icon: "fa-solid fa-image",
    enabled: true,
  },
  {
    value: "Depoimentos",
    action: () => {
      if (session?.is_plus) {
        navigateCanvas(EOffcanvasViews.ratings, null, false);
        return;
      }
      navigateCanvas(EOffcanvasViews.subscription, null, false);
    },
    icon: "fa-solid fa-star",
    enabled: session?.is_plus,
  },
  {
    value: "Idiomas",
    action: () => navigateCanvas(EOffcanvasViews.languages, null, false),
    icon: "fa-solid fa-earth",
    enabled: true,
  },
  {
    value: "Vídeo de introdução",
    action: () => {
      if (session?.is_plus) {
        navigateCanvas(EOffcanvasViews.intro_video, null, false);
        return;
      }
      navigateCanvas(EOffcanvasViews.subscription, null, false);
    },
    icon: "fa-brands fa-youtube",
    enabled: session?.is_plus,
  },
  {
    value: "Valor da sessão",
    action: () =>
      navigateCanvas(EOffcanvasViews.appointment_price, null, false),
    icon: "fa-solid fa-dollar",
    enabled: true,
  },
  {
    value: "Informações de formação",
    action: () => navigateCanvas(EOffcanvasViews.about, null, false),
    icon: "fa-solid fa-image-portrait",
    enabled: true,
  },
  {
    value: "Fotos do CRP",
    action: () => navigateCanvas(EOffcanvasViews.crp, null, false),
    icon: "fa-solid fa-id-card",
    enabled: true,
  },
  {
    value: "Especialidades",
    action: () => navigateCanvas(EOffcanvasViews.specialties, null, false),
    icon: "fa-solid fa-stethoscope",
    enabled: true,
  },
  {
    value: "Abordagens",
    action: () => navigateCanvas(EOffcanvasViews.approaches, null, false),
    icon: "fa-solid fa-tasks",
    enabled: true,
  },
  {
    value: "Disponibilidade de horários",
    action: () => navigateCanvas(EOffcanvasViews.schedule_info, null, false),
    icon: "fa-solid fa-clock",
    enabled: true,
  },
  {
    value: "Gênero",
    action: () => navigateCanvas(EOffcanvasViews.gender, null, false),
    icon: "fa-solid fa-venus-mars",
    enabled: true,
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item, index) => {
      return _createElementVNode("div", {
        key: index,
        class: _normalizeClass(["d-flex align-items-center py-4 cursor-pointer", { 'border-bottom': index !== items.length - 1 }]),
        onClick: item.action
      }, [
        _createElementVNode("i", {
          class: _normalizeClass([[
          item.icon,
          { 'text-primary50': !item.enabled, 'text-primary': item.enabled },
        ], "fa-lg"]),
          style: {"width":"35px"}
        }, null, 2),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", {
              class: _normalizeClass(["mb-0 text-paragraph", { 'text-primary50': !item.enabled }])
            }, _toDisplayString(item?.value), 3),
            (!item.enabled)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Paiapp +"))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_5
      ], 10, _hoisted_2)
    }), 64))
  ]))
}
}

})